import { render, staticRenderFns } from "./activity-detail.vue?vue&type=template&id=90ef9694&scoped=true&"
import script from "./activity-detail.vue?vue&type=script&lang=js&"
export * from "./activity-detail.vue?vue&type=script&lang=js&"
import style0 from "./activity-detail.vue?vue&type=style&index=0&id=90ef9694&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ef9694",
  null
  
)

export default component.exports